import clsx from "clsx";

const PetWeight: React.FC<{ weight: string; className?: string }> = (props) => {
  return props?.weight === null ? (
    <span className="text-xs text-red-500">No Weight</span>
  ) : (
    <span className={clsx(props?.className)}>{props?.weight ? `${props?.weight} KG` : "No Weight"}</span>
  );
};

export default PetWeight;
